import React from 'react';
import { Outlet,useLocation } from 'react-router-dom';
import PreviewPage from '../preview/PreviewPage';
import PreviewPost from '../preview/PreviewPost';


export default function Preview() {

	const location = useLocation();
    const params = new URLSearchParams(location.search);
    const preview = params.get('preview');

    const postsPageSlug = WP_API_Settings.posts_page_slug;
    console.log('Preview postsPageSlug', postsPageSlug)

    
    //check for preview=true in the URL
    if (preview) {
        //check for preview_id this is use for revision preview
        if (params.get('preview_id')) {
            //check for WP_API_Settings.posts_page_slug
            if (postsPageSlug && location.pathname.includes(postsPageSlug)) {
                return <PreviewPost preview_id={params.get('preview_id')} preview_nonce={params.get('preview_nonce')} />;
            } else {
                return <PreviewPage preview_id={params.get('preview_id')} preview_nonce={params.get('preview_nonce')}/>;
            }
        }
        //check if page id is present
        if (params.get('page_id')) {
            return <PreviewPage page_id={params.get('page_id')} />;
        } else if (params.get('p')) {
            return <PreviewPost post_id={params.get('p')} />;
        }
    }
    //if no preview, return the normal page
    return <Outlet />;
}